import React from 'react';
import { makeStyles } from '@material-ui/core';

import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles(() => ({
  loadingContainer: {
    height: 'calc(100% - 90px)',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
}));

const SkillsLoading = ({ loading = false }) => {
  const classes = useStyles();

  if (!loading) {
    return null;
  }

  return (
    <div className={classes.loadingContainer}>
      <Skeleton variant="rect" width={35} height={260} />
      <Skeleton variant="rect" width={35} height={240} />
      <Skeleton variant="rect" width={35} height={130} />
      <Skeleton variant="rect" width={35} height={210} />
      <Skeleton variant="rect" width={35} height={180} />
      <Skeleton variant="rect" width={35} height={220} />
      <Skeleton variant="rect" width={35} height={120} />
      <Skeleton variant="rect" width={35} height={290} />
      <Skeleton variant="rect" width={35} height={120} />
      <Skeleton variant="rect" width={35} height={60} />
      <Skeleton variant="rect" width={35} height={120} />
      <Skeleton variant="rect" width={35} height={210} />
      <Skeleton variant="rect" width={35} height={180} />
      <Skeleton variant="rect" width={35} height={220} />
      <Skeleton variant="rect" width={35} height={120} />
      <Skeleton variant="rect" width={35} height={290} />
      <Skeleton variant="rect" width={35} height={120} />
      <Skeleton variant="rect" width={35} height={60} />
    </div>
  );
};

export default SkillsLoading;
